export const downloadStringAsFile = (function () {
    const a = document.createElement('a');
    document.body.appendChild(a);
    // @ts-ignore
    // noinspection JSConstantReassignment
    a.style = 'display: none';

    return function (data, fileName) {
        const url = `data:application/octet-stream;base64,${data}`;
        fetch(url)
            .then(r => r.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            });
    };
}());
